import CreditRating from "../../icons/CreditRating";

export default function BoxInfoOtpInquiry({ title }: any) {
    return (
        <div className="p-4">
            <div
                className="text-center text-[var(--primary-text-color)] !mt-4 w-fit h-fit"
                style={{ marginTop: '200px', fontSize: '14px', margin: 'auto' }}
            >
                <CreditRating className="text-[var(--primary-text-color)]" />
            </div>
            <div
                className="text-center text-[var(--primary-text-color)] !mt-8"
                style={{
                    marginTop: '40px',
                    fontSize: '14px',
                    textAlign: 'center',
                    display: ' block',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 'auto',
                }}
            >
                {title}

            </div>
            <div
                className="text-center text-[var(--primary-text-color)] mt-4  "
                style={{ fontSize: '14px' }}
            >
                کد دریافت شده را در کادر زیر وارد نمایید.
            </div>
        </div>
    )
}
